(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lidar-hd", [], factory);
	else if(typeof exports === 'object')
		exports["lidar-hd"] = factory();
	else
		root["lidar-hd"] = factory();
})(self, function() {
return 